<div *ngIf="isLoading" class="loading-overlay">
  <p-progressSpinner></p-progressSpinner>
</div>
<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><em class="fas fa-print"></em></span>{{ "AutoPrintReprint.Header" | translate }}
  </h1>
  <p-card>
    <form [formGroup]="reprintForm">
    <div class="p-fluid formgrid grid">
      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label><span class="requiredStar">*</span>{{ "AutoPrintReprint.Form.Facility" | translate }}</label>
        <div class="item">
            <laas-facility-dropdown 
              formControlName="facility" 
              [isSingle]="true" 
              (onOptionDataChange)="optionsDataOnChange($event, 'facility')">
            </laas-facility-dropdown> 
            <div *ngIf="((submitted || reprintForm.controls.facility.touched) && reprintForm?.controls?.facility?.errors?.required )" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label><span class="requiredStar">*</span>{{ "AutoPrintReprint.Form.Printer" | translate }}</label>
        <div class="item">
            <p-dropdown
              formControlName="printer"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [showClear]="true"
              [(ngModel)]="reprintParams.printer"
              [options]="printerCodeOptions"
            ></p-dropdown>
            <div *ngIf="((submitted || reprintForm.controls.printer.touched) && reprintForm?.controls?.printer?.errors?.required )" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label><span class="requiredStar">*</span>{{ "AutoPrintReprint.Form.DocType" | translate }}</label>
        <div class="item">
          <p-multiSelect
            formControlName="docType"
            optionLabel="label"
            optionValue="value"
            placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
            [(ngModel)]="reprintParams.docType"
            [options]="docTypeOptions"
            [filter]="true"
            filterBy="label"
          ></p-multiSelect>
          <div *ngIf="((submitted || reprintForm.controls.printer.touched) && reprintForm?.controls?.printer?.errors?.required )" >
            <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-4 laas-calendar">
        <label><span class="requiredStar">*</span>{{ "AutoPrintReprint.Form.ReprintInterval" | translate }}</label>
        <div class="item">
        <laas-calendar
          #reprintDt
          [showRangeMode]="true"
          [showStartMode]="true"
          [showCustomTime]="true"
          (onDateChange)="dateOnChange($event)">
        </laas-calendar>
        <div *ngIf="((submitted || reprintForm.controls.createDtStart.touched) && reprintForm?.controls?.createDtStart?.errors?.required )" >
          <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
        </div>
      </div>
      </div>
    </div>
    <div class="grid">
      <div class="col">
        <button pButton pRipple label="列印" (click)="printBtnClick()"></button>
      </div>
    </div>
  </form>
  </p-card>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
